import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-440b608a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "line" };
const _hoisted_2 = {
    key: 0,
    class: "title"
};
const _hoisted_3 = { class: "currency" };
import NumberText from '@/materials/atoms/NumberText.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        step: { default: 1 },
        title: { default: '' },
        currency: { default: '' },
        mode: null
    },
    setup(__props) {
        const props = __props;
        const isSmartPhone = window.innerWidth <= 960;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (props.title)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("label", null, _toDisplayString(props.title), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(NumberText, {
                    step: props.step,
                    mode: props.mode,
                    height: isSmartPhone ? 33 : 22,
                    fontSize: 13,
                    plusMinus: isSmartPhone
                }, null, 8, ["step", "mode", "height"]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("label", null, _toDisplayString(props.currency), 1)
                ])
            ]));
        };
    }
});
